<template>
  <div>
    <slot name="detail">
      <v-row justify="center">
        <v-col md="12">
          <v-card elevation="0" outlined>
            <v-card-title>
              <v-row justify="center">
                <v-col md="12">
                  <v-row>

                    <v-col md="2">
                      <span class="subtitle-2">Día de solicitud</span>
                      <h5 class="subtitle-2 ">
                        {{ DataOrder.createdAt ? moment(DataOrder.createdAt).format('DD-MM-YYYY') : 'NA' }}</h5>
                    </v-col>
                    <v-col md="3">
                      <span class="subtitle-2">Mercancía lista</span>
                      <h5 class="subtitle-2 ">
                        {{ DataOrder.departureDate ? moment(DataOrder.departureDate).format('DD-MM-YYYY') : 'NA' }}</h5>
                    </v-col>

                    <v-col md="5">
                      <h2 class="font-weight-regular" :style="DataOrder.isExpired == false ? 'color:black' : 'color:red'">{{ DataOrder.refCode ? DataOrder.refCode : 'NA' }}</h2>
                      <v-icon v-if="DataOrder.urgent" left size="40" color="red">mdi-alert-outline</v-icon>
                    </v-col>

                    <v-col md="2" style="text-align: right">
                      <v-menu offset-y v-if="DataOrder.statusOrder!='Cancelada'">
                        <template v-slot:activator="{on: menu}">
                          <v-btn small icon v-on="menu" v-if="DataOrder.statusOrder !== 'Vendida'">
                            <v-icon>mdi-chevron-down</v-icon>
                          </v-btn>
                        </template>
                        <v-card>
                          <!--                          <v-list-item>
                                                      <v-list-item-content @click="SellOrder">
                                                        Vendida
                                                      </v-list-item-content>
                                                    </v-list-item>-->
                          <v-list-item @click="ShowEditQuote">
                            <v-list-item-content>
                              Editar
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item @click="ShowDuplicatedQuote">
                            <v-list-item-content>
                              Duplicar Cotización
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item @click="ShowRenegotiation" :disabled="DataOrder.statusOrder === 'Pendiente Pricing'">
                            <v-list-item-content>
                              Renegociar
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item @click="ShowCancelation">
                            <v-list-item-content>
                              Cancelar
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item @click="SendToClient" :disabled="DataOrder.statusOrder === 'Pendiente Pricing'">
                            <v-list-item-content @click="SendToClient">
                              Enviar a Cliente
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-menu>
                      <v-btn small icon @click="closeOrder()">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <br>
                </v-col>

              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row>

                <v-col md="2">
                  <span>Origen</span><br>
                  <!--                  <span class="font-weight-bold">{{ DataOrder.origin[0].country }}</span>-->
                  <span class="font-weight-bold">{{ DataOrder.origin[0].address }}</span>
                </v-col>

                <v-col md="2">
                  <span>Destino</span><br>
                  <span class="font-weight-bold">{{ DataOrder.destination[0].address }}</span>
                </v-col>

                <v-col md="2">
                  <span>Tipo</span><br>
                  <span class="font-weight-bold">{{ DataOrder.orderType.description }}</span>
                </v-col>

                <!--                <v-col md="2">-->
                <!--                  <span>CBM Total</span><br>-->
                <!--                  <span class="font-weight-bold">{{ DataOrder.cbmTotal }}</span>-->
                <!--                </v-col>-->


                <v-col md="2">
                  <span>Target</span><br>
                  <span
                      class="font-weight-bold">{{ DataOrder.budget }}</span>
                </v-col>

                <v-col md="2">
                  <span>Industria</span><br>
                  <span
                      class="font-weight-bold">{{ DataOrder.industry.description }}</span>
                </v-col>

                <v-col md="2">
                  <span>Commodity</span><br>
                  <span class="font-weight-bold">{{ DataOrder.commodity ? DataOrder.commodity : 'NA' }}</span>
                </v-col>

                <v-col md="2">
                  <span>Frecuencía</span><br>
                  <span
                      class="font-weight-bold">{{ DataOrder.frequency }}</span>
                </v-col>

                <v-col md="2" v-if="DataOrder.pricer != null">
                  <span>Responsable pricing</span><br>
                  <span class="font-weight-bold">
                        {{ DataOrder.pricer.firstName ? DataOrder.pricer.firstName : 'NA' }}
                        {{ DataOrder.pricer.lastName ? DataOrder.pricer.lastName : 'NA' }}
                      </span>
                </v-col>


                <v-col md="2">
                  <span>Cliente</span><br>
                  <span class="font-weight-bold">{{ DataOrder.client.name ? DataOrder.client.name : 'NA' }}</span>
                </v-col>

                <v-col md="2">
                  <span>Transbordo</span><br>
                  <span class="font-weight-bold">{{ DataOrder.landTransfer ? 'Si' : 'No' }}</span>
                </v-col>

                <v-col md="2" v-if="DataOrder.landServiceId">
                  <span>Land Service</span><br>
                  <span class="font-weight-bold">{{ landService.Description }}</span>
                </v-col>

                <v-col md="2" v-if="DataOrder.goodsCost != null">
                  <span>Costo de mercancia</span><br>
                  <span class="font-weight-bold">{{ DataOrder.goodsCost }}</span>
                </v-col>

                <v-col md="2">
                  <span>Time to request provider</span><br>
                  <span v-if="DataOrder.orderStatusLifetime.length" class="font-weight-bold">{{
                      DataOrder.orderStatusLifetime[0].dueDate | luxon({
                        output: {
                          zone: "local",
                          format: "short"
                        }
                      })
                    }}</span>
                </v-col>

                <v-col md="2">
                  <span>Expected price time</span><br>
                  <span v-if="DataOrder.orderStatusLifetime.length" class="font-weight-bold">{{
                      DataOrder.orderStatusLifetime[1].dueDate | luxon({
                        output: {
                          zone: "local",
                          format: "short"
                        }
                      })
                    }}</span>
                </v-col>





              </v-row>
            </v-card-text>
            <v-card-actions>

              <v-row justify="center">
                <v-col md="12">
                  <v-btn v-if="show == false" class="offset-6" icon @click="show = !show">
                    <v-icon size="35">{{ 'mdi-arrow-down-drop-circle-outline' }}</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
            <v-expand-transition mode="out-in">
              <div v-show="show">
                <v-card-text>

                  <v-row>
                    <v-col md="12">
                      <span>Comentarios</span><br>
                      <v-card outlined>
                        <v-card-text class="font-weight-bold" style="white-space: pre-wrap;">{{ DataOrder.comments }}</v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col md="12">
                      <br><br>
                      <v-card outlined dense>
                        <v-row>
                          <v-col md="8">
                            <v-card-title class="black--text">Detalle de Carga</v-card-title>
                          </v-col>
                          <v-col md="4">
                            <br>
                            <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" rounded text v-bind="attrs" v-on="on">
                                  <span
                                      class="font-weight-bold black&#45;&#45;text">Servicios ({{
                                      DataOrder.srv.normal.length
                                    }})</span>
                                  <v-icon color="black">mdi-chevron-down</v-icon>

                                </v-btn>
                              </template>


                              <v-card>
                                <v-list subheader>
                                  <v-subheader>Servicios</v-subheader>
                                  <div v-for="item in DataOrder.srv.normal" :key="item.id">
                                    <v-list-item>
                                      {{ item.service.name }}
                                    </v-list-item>
                                  </div>
                                </v-list>



                                <v-card-actions>
                                </v-card-actions>
                              </v-card>
                            </v-menu>

                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-width="100">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" rounded text v-bind="attrs" v-on="on">
                                  <span
                                      class="font-weight-bold black&#45;&#45;text">Servicios Adicionales ({{
                                      DataOrder.srv.optional.length
                                    }})</span>
                                  <v-icon color="black">mdi-chevron-down</v-icon>

                                </v-btn>
                              </template>


                              <v-card>
                                <v-list subheader>
                                  <v-subheader>Servicios Adicionales</v-subheader>
                                  <div v-for="item in DataOrder.srv.optional" :key="item.id">
                                    <v-list-item>
                                      {{ item.service.name }}
                                    </v-list-item>
                                  </div>
                                </v-list>



                                <v-card-actions>
                                </v-card-actions>
                              </v-card>
                            </v-menu>



                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-row v-for="data in DataOrder.cargo" :key="data.id">

                            <v-col md="2">
                              <span>Servicio</span>
                              <br>
                              <span
                                  class="font-weight-bold">{{ DataOrder.transportationCategory.description }} - {{ data.container ? data.container.description : '' }}</span>
                            </v-col>

                            <v-col md="2">
                              <span>Cantidad</span><br>
                              <span
                                  class="font-weight-bold">{{ data.quantity }}</span>
                            </v-col>

                            <v-col md="2">
                              <span>Peso</span><br>
                              <span
                                  class="font-weight-bold">{{data.legal ? 'Legal' : data.weight }}</span>
                              <small v-if="!data.legal" >{{data.weightUnitMeasure}}</small>
                            </v-col>

                            <v-col md="2" v-if="DataOrder.transportationCategoryId == 1">
                              <span>Medidas</span><br>
                              <span class="font-weight-bold">{{ data.large.toFixed(2) }}x{{ data.width.toFixed(2) }}x{{ data.height.toFixed(2) }}</span>
                              <small>{{ data.unitMeasure }}</small>
                            </v-col>

                            <v-col md="2">
                              <span>Peligroso</span><br>
                              <span class="font-weight-bold">{{ data.dangerous ? 'Si' : 'No' }}</span>
                            </v-col>

                            <v-col md="2">
                              <span>No Estibable</span><br>
                              <span class="font-weight-bold">{{ data.stackable ? 'Si' : 'No' }}</span>
                            </v-col>

                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>


                  <v-row justify="center">
                    <v-col md="12">
                      <v-btn class="offset-6" icon @click="show = !show">
                        <v-icon size="35">{{ 'mdi-arrow-up-drop-circle-outline' }}</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
    </slot>

    <v-dialog v-model="dialog" width="800">
      <register-shipment-dialog
          v-on:sellOrder="sellOrder = $event"
          v-on:sellDataOrder="recibeDataOrder"
          v-on:closeDialog="dialog= $event"
      >
      </register-shipment-dialog>
    </v-dialog>
  </div>

</template>

<script>
import RegisterShipmentDialog from "../Operations/registerShipmentDialog";
import folio_mixin from "@/mixins/folio_mixin";

export default {
  name: "DetailOrderTerrestre",
  mixins: [folio_mixin],
  components: {
    RegisterShipmentDialog

  },
  props: {
    id: Number,
    stateModal: Boolean
  },
  watch: {

    sellOrder: function (val) {
      if (val)
        this.SellOrder();
    },

    id: function (val) {
      if (val) {
        this.GetDataOrder();

      }
    },

    /*showDialogEdit:function (){
      this.$emit('ShowDialog',this.showDialogEdit)
    },
    showNewComment:function () {
      this.$emit('ShowComment',this.showNewComment)
    }*/
  },
  data() {
    return {
      menu: false,
      menu2: false,
      showDialogDuplicated: false,
      tab: 0,
      landTransportation: '',
      show: false,
      dialog: false,
      sellOrder: false,
      shipment: [],
      active: false,
      showDialogCancelation: false,
      showDialogEdit: false,
      showNewComment: false,
      showExpand: false,
      editQuote: false,
      OrderStatus: [{
        name: 'Solicitado a Proveedor'
      },

        {
          name: 'Enviado a Ventas'
        },
      ],
      DataOrder: [],
      LandServices: [
        {
          Id: 1,
          Description: 'Consolidado',
          Status: 1
        },

        {
          Id: 2,
          Description: 'Dedicado',
          Status: 1
        },

        {
          Id: 3,
          Description: 'Hot Shot',
          Status: 1
        },
      ],
    }
  },
  computed: {
    landService(){
      return this.LandServices.find(el => el.Id === this.DataOrder.landServiceId)
    }
  },
  methods: {
    recibeDataOrder(data) {
      data.QuotationId = this.quotationId;
      this.shipment = data;
      console.log(data);
    },
    ShowRenegotiation: function () {
      this.active = false;
      this.active = true;
      this.$emit('ShowRenegotiaton', true)
    },
    ShowDuplicatedQuote: function () {
      this.showDialogDuplicated = true;
      this.editQuote = false;
      this.editQuote = true;
      this.$emit('ShowDialogDuplicated', this.showDialogDuplicated)
    },

    SellOrder: function () {
      this.setOrderSold().then(({data}) => {
        if (data.code === 200) {
          this.$toast.info('Cotización actualizada con éxito')
          setTimeout(() => {
            this.$router.push('/Sales')
          }, 1000)
        } else {
          console.error(data)
          this.$toast.error('Hubo un error, contactese con el administrador')
        }
      }).catch(error => {
        console.error(error)
        this.$toast.error('Hubo un error, contactese con el administrador')
      }).finally(() => {
        this.sellOrder = false;
      })
    },

    setOrderSold: function () {
      return this.$http.post(`Orders/${this.id}/sold`, this.shipment)
    },
    SendToClient: function () {
      this.active = false;
      this.active = true;
      this.$emit('SendToClient', true)
    },


    ShowNewComment: function () {
      this.active = false;
      this.active = true;
      this.$emit('ShowComment', true)
    },
    ShowCancelation: function () {
      console.log('Emit cancelation event')
      this.showDialogCancelation = true;
      this.$emit('OpenCancelationModal', true)
    },
    ShowEditQuote: function () {
      this.showDialogEdit = true;
      this.editQuote = false;
      this.editQuote = true;
      this.$emit('ShowDialog', this.showDialogEdit)
    },

    mapOrder(order) {
      return {
        Id: order.id,
        TransportationId: order.transportationId,
        CommentsToPricer: order.commentsToPricer,
        TransportationCategoryId: order.transportationCategoryId,
        IncotermId: order.incotermId,
        OrderTypeId: order.orderTypeId,
        LandTransfer: order.landTransfer,
        LandTransportation: order.landTransportation,
        LandDedicated: order.landDedicated,
        LandFull: order.landFull,
        Terms: order.terms,
        Origin: order.origin,
        Destination: order.destination,
        StatusOrder: order.statusOrder,
        Pol: order.pol,
        Pod: order.pod,
        DepartureDate: order.departureDate,
        IndustryId: order.industryId,
        Budget: order.budget,
        Commodity: order.commodity,
        InsideBillOfLanding: order.insideBillOfLanding,
        Cargo: order.cargo,
        Services: order.services,
        ClientId: order.clientId,
        PricerId: order.pricerId,
        SalesManagerId: order.salesManagerId,
        Pricer: order.pricer,
        SalesManager: order.salesManager,
        Client: order.client,
        OrderType: order.orderType,
        Currency: order.currency,
        Incoterm: order.incoterm,
        Transportation: order.transportation,
        TransportationCategory: order.transportationCategory,
        Industry: order.industry,
        Frequency: order.frequency,
        Urgent: order.urgent,
        Comments: order.comments,
        CreatedAt: order.createdAt,
      }
    },

    MapOrderToList(obj) {
      let order = this.mapOrder(obj)

      this.formatFolio(order);

      this.DataOrder.folio = order.folio;

      this.DataOrder.cargo.forEach(element => {
        if (element.type == "Container") {
          if (element.weight <= 21000) {
            element.legal = true;
          } else
            element.legal = false;
        }
      })

      return order
    },

    closeOrder: function () {
      this.$router.push('/Sales')
    },


    GetDataOrder: function () {

      this.$emit('idOrder', this.id);

      console.log('Hello')

      this.$store.dispatch('working', true)

      this.$http.get(`Orders/${this.id}`).then(response => {
        console.log(response)
        this.DataOrder = response.data.data;
        var fecha = this.DataOrder.date;
        fecha = new Date(fecha);
        this.DataOrder.date = fecha;
        console.log(this.DataOrder.date);
        console.log("DETAIL", this.DataOrder);
        // this.id = 0;
        this.MapOrderToList(this.DataOrder);
        this.$emit('statusOrder', this.DataOrder.statusOrder);
        console.log(this.DataOrder)
        console.log(this.MapOrderToList(this.DataOrder))
        let cbmTotal = 0;
        this.DataOrder.cargo.forEach(element => {
          cbmTotal = cbmTotal + element.volumetricWeight
        })
        this.DataOrder.cbmTotal = cbmTotal

        this.DataOrder.cargo.forEach(element => {

          if (element.large>0 && element.width>0 && element.height>0){
            this.showMeasure = true;
          }
        })


        // Arrange Services
        this.DataOrder.srv = {
          normal: [],
          optional: []
        };
        const optionalServices = [15,8,1,16,17,18,19,20];

        this.DataOrder.services.forEach((el) => {
          let isOptional = optionalServices.includes(el.serviceId);
          if(isOptional){
            this.DataOrder.srv.optional.push(el);
          }else{
            this.DataOrder.srv.normal.push(el);
          }
        });
        this.DataOrder.map((element) => {
          let aux = []
          if (element.orderStatusLifetime){
            aux = element.orderStatusLifetime
          }
          return{
            ...element,
            orderStatusLifetime: aux
          }
        })


      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.$store.dispatch('working', false);
      })
    }
  },
  mounted() {
    this.GetDataOrder();
  }

}
</script>


<style scoped>
>>> .v-application--wrap {
  min-height: 0px
}

</style>
